import { isContainedInList } from "helpers/row-logic-helper";
import {
  DSCR_TYPES
} from "@loanbossinc/component-library";
import { get } from "lodash";

export const shouldShowDscrDebtServiceTermTrailingMonthsEdit = data => isContainedInList(data.covenants, "dscrTypeId", [
  DSCR_TYPES.ACTUAL_TRAILING_CASHFLOWS
]);

export const shouldShowDscrDebtServiceTermProjectedMonthsEdit = data => isContainedInList(data.covenants, "dscrTypeId", [
  DSCR_TYPES.ACTUAL_PROJECTED_CASHFLOWS
]);

export const shouldHypotheticalAmortizationsEdit = data => isContainedInList(data.covenants, "dscrTypeId", [
  DSCR_TYPES.HYPOTHETICAL_AMORTIZATION
]);

export const shouldShowDscrDebtServiceTermTrailingMonths = data => Boolean(get(data, "covenants.dscrDebtServiceTerm")) && isContainedInList(data.covenants, "dscrTypeId", [
  DSCR_TYPES.ACTUAL_TRAILING_CASHFLOWS
]);

export const shouldShowDscrDebtServiceTermProjectedMonths = data => Boolean(get(data, "covenants.dscrDebtServiceTerm")) && isContainedInList(data.covenants, "dscrTypeId", [
  DSCR_TYPES.ACTUAL_PROJECTED_CASHFLOWS
]);

export const shouldHypotheticalAmortizations = data => (
  Boolean(get(data, "covenants.dscrTreasuryLookback")) ||
  Boolean(get(data, "covenants.dscrAmortTerm")) ||
  Boolean(get(data, "covenants.dscrFixedRate")) ||
  Boolean(get(data, "covenants.dscrTreasurySpread")) ||
  Boolean(get(data, "covenants.dscrFloatingRateSpread"))) &&
  isContainedInList(data.covenants, "dscrTypeId", [DSCR_TYPES.HYPOTHETICAL_AMORTIZATION]);

export const shouldShowDscrStabilized = loan => Boolean(get(loan, "covenants.dscrStabilized"));

export const shouldShowDscrCovenants = loan => Boolean(get(loan, "covenants.dscrCovenants"));

export const shouldShowDebtYieldStabilized = loan => Boolean(get(loan, "covenants.debtYieldStabilized"));

export const shouldShowDebtYieldCovenants = loan => Boolean(get(loan, "covenants.debtYieldCovenants"));

export const shouldShowLtvStabilized = loan => Boolean(get(loan, "covenants.ltvStabilized"));

export const shouldShowLtvCovenants = loan => Boolean(get(loan, "covenants.ltvCovenants"));

export const shouldShowOccupancy = loan => Boolean(get(loan, "covenants.occupancy"));

export const shouldShowdscrType = loan => Boolean(get(loan, "covenants.dscrType"));

export const shouldShowOccupancyCovenants = loan => Boolean(get(loan, "covenants.occupancyCovenants"));

export const shouldShowLtc = loan => Boolean(get(loan, "covenants.ltc"));

export const shouldShowLtcCovenants = loan => Boolean(get(loan, "covenants.ltcCovenants"));

export const shouldShowDscrAsIs = loan => Boolean(get(loan, "covenants.dscrAsIs"));

export const shouldShowDebtYieldAsIs = loan => Boolean(get(loan, "covenants.debtYieldAsIs"));

export const shouldShowLtvAsIs = loan => Boolean(get(loan, "covenants.ltvAsIs"));

export const shouldShowFinancialCovenantsMisc = loan => Boolean(get(loan, "covenants.financialCovenantsMisc"));

export const shouldShowDscrSubSection = loan => Boolean(get(loan, "covenants.dscrStabilized")) ||
    Boolean(get(loan, "covenants.dscrBeginTestingDate")) ||
    Boolean(get(loan, "covenants.dscrFrequency")) ||
    Boolean(get(loan, "covenants.dscrCovenants")) ||
    Boolean(get(loan, "covenants.dscrTypeId")) ||
    Boolean(get(loan, "covenants.dscrDebtServiceTerm")) ||
    Boolean(get(loan, "covenants.dscrTreasuryLookback")) ||
    Boolean(get(loan, "covenants.dscrAmortTerm")) ||
    Boolean(get(loan, "covenants.dscrFixedRate")) ||
    Boolean(get(loan, "covenants.dscrTreasurySpread")) ||
    Boolean(get(loan, "covenants.dscrFloatingRateSpread"));
export const shouldShowDebtYieldSubSection = loan => Boolean(get(loan, "covenants.debtYieldStabilized")) ||
    Boolean(get(loan, "covenants.debtYieldBeginTestingDate")) ||
    Boolean(get(loan, "covenants.debtYieldFrequency")) ||
    Boolean(get(loan, "covenants.debtYieldCovenants"));

export const shouldShowLtvSubSection = loan => Boolean(get(loan, "covenants.ltvStabilized")) ||
    Boolean(get(loan, "covenants.ltvBeginTestingDate")) ||
    Boolean(get(loan, "covenants.ltvFrequency")) ||
    Boolean(get(loan, "covenants.ltvCovenants"));

export const shouldShowOccupancySubSection = loan => Boolean(get(loan, "covenants.covenants.occupancy")) ||
    Boolean(get(loan, "covenants.covenants.occupancyBeginTestingDate")) ||
    Boolean(get(loan, "covenants.covenants.occupancyFrequency")) ||
    Boolean(get(loan, "covenants.covenants.occupancyCovenants"));

export const shouldShowAsIsSubSection = loan => Boolean(get(loan, "covenants.dscrAsIs")) ||
    Boolean(get(loan, "covenants.debtYieldAsIs")) ||
    Boolean(get(loan, "covenants.ltvAsIs")) ||
    Boolean(get(loan, "covenants.financialCovenantsMisc"));

export const shouldShowLtcSubSection = loan => Boolean(get(loan, "covenants.ltc")) ||
    Boolean(get(loan, "covenants.ltcBeginTestingDate")) ||
    Boolean(get(loan, "covenants.ltcFrequency")) ||
    Boolean(get(loan, "covenants.ltcCovenants"));
